// extracted by mini-css-extract-plugin
export default {"tileTitle":"TopFrequencyWords_tileTitle__GcXfC","loading":"TopFrequencyWords_loading__z8W2U"};